import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const TruncatedTextWithTooltip = ({ text, maxLength = 15 }) => {
    const truncatedText = text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    return (
        <Tippy content={text.length > maxLength ? text : ""} disabled={text.length <= maxLength}>
            <span
                className="text-right"
                style={{ whiteSpace: "nowrap" }}
            >
                {truncatedText}
            </span>
        </Tippy>
    );
};

export default TruncatedTextWithTooltip;
